export const codeStates = {
  match: 'match',
  missing: 'missing',
  mismatch: 'mismatch',
  invalid: 'invalid',
}

export const decisions = {
  pending: 'pending',
  accepted: 'accepted',
  discarded: 'discarded',
}
